export const token  = s => s.token;
export const expiresTime  = s => s.expiresTime;
export const userInfo  = s => s.userInfo;
export const isRunLogin  = s => s.isRunLogin;
export const serchkey  = s => s.serchkey;
export const serchCon  = s => s.serchCon;